
import _ from "lodash"
import {
    REPAIR,
    REPAIR_SUCCESS,
    REPAIR_OPEN_SUCCESS,
    REPAIR_CLOSE_SUCCESS,
    REPAIR_ERROR,
    ADD_REPAIR,
    ADD_REPAIR_SUCCESS,
    ADD_REPAIR_ERROR,
    UPDATE_REPAIR,
    UPDATE_REPAIR_SUCCESS,
    UPDATE_REPAIR_ERROR,
    DELETE_REPAIR,
    DELETE_REPAIR_ERROR,
    DELETE_REPAIR_SUCCESS,
    HISTORIC_DASHBOARD_REPAIR,
    HISTORIC_DASHBOARD_REPAIR_ERROR,
    HISTORIC_DASHBOARD_REPAIR_SUCCESS,
    REPAIR_CLOSE_ERROR,
    REPAIR_OPEN_ERROR,
    CLOSE_REPAIR_SUCCESS,
    CANCEL_REPAIR_SUCCESS,
    REPAIRS_FILTERS,
    REPAIRS_FILTERS_ERROR,
    REPAIRS_FILTERS_SUCCESS

} from "../constants/repairConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
    dashboardRepairData:{
        openS:[],
        closeS:[]
    },
    openRepairs:[],
    closedRepairs:[]
};

function repairReducer(state = initialState, action) {
    switch (action.type) {
        case REPAIR:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'REPAIRS',
                'loadingMessage': 'THE REPAIRS ARE BEING LOADED',
                'type': action.type
            });
        case REPAIR_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case REPAIR_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'repairData': action.data,
                'type': action.type
            });

        case REPAIRS_FILTERS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'REPAIRS',
                'loadingMessage': 'THE REPAIRS ARE BEING LOADED',
                'type': action.type
            });
        case REPAIRS_FILTERS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case REPAIRS_FILTERS_SUCCESS:

            const currentCommunityId = action.communityId;
            const oldCommunityID = state?.dashboardRepairData.openS[0]?.communityId? state?.dashboardRepairData.openS[0]?.communityId : state?.dashboardRepairData.closeS[0]?.communityId? state?.dashboardRepairData.closeS[0]?.communityId: undefined

            const tab = action.tab? action.tab : 1 //1 for opened and scheduled 2 for completed
            const newData = state.dashboardRepairData


            if(currentCommunityId===oldCommunityID){ // Same community, concat the data
   
                if(tab===1){ //If the page is 0 we put the data, if is another page we concat the data
                    const open = state.dashboardRepairData.openS.filter(repair => !action.data.some(newRep => newRep._id === repair._id))

                    newData.openS = action.page>0? open.concat(action.data) : [...action.data]

                }else if(tab===2){
                    
                    const closed = state.dashboardRepairData.closeS.filter(repair => !action.data.some(newRep => newRep._id === repair._id))

                    newData.closeS =action.page>0? closed.concat(action.data) : [...action.data]
                }
    
            }
         
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'dashboardRepairData': newData,
                'type': action.type
            });
        case ADD_REPAIR:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'REPAIRS',
                'loadingMessage': 'THE REPAIR IS BEING SAVED',
                'type': action.type
            });
        case ADD_REPAIR_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_REPAIR_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'repairData': [...state.repairData, action.data],
                'type': action.type
            });
        case UPDATE_REPAIR:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'REPAIRS',
                'loadingMessage': 'THE REPAIR IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_REPAIR_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_REPAIR_SUCCESS:

            const oldRepairData = state.repairData ? state.repairData : []

            let newRepairData = [...oldRepairData];
            if (typeof (oldRepairData) === 'object' && oldRepairData.length > 0) {

                newRepairData = oldRepairData.map(repair => { if (repair._id === action.data._id) { return action.data } else { return repair } })
            }


            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'repairData': newRepairData,
                'type': action.type
            });
        case DELETE_REPAIR:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'REPAIRS',
                'loadingMessage': 'THE REPAIR IS BEING DELETED',
                'type': action.type
            });
        case DELETE_REPAIR_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_REPAIR_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'repairData': state.repairData.filter(repair => repair._id !== action.data),
                'type': action.type

            });

        case HISTORIC_DASHBOARD_REPAIR:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'REPAIRS',
                'loadingMessage': 'THE REPAIRS DASHBOARD ARE BEING LOADED',
                'type': action.type
            });

        case HISTORIC_DASHBOARD_REPAIR_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });

        case HISTORIC_DASHBOARD_REPAIR_SUCCESS:

            const commId = (action && action.communityId)? action.communityId : undefined;
            let oldCommId =  undefined;

            
            if(state && state.dashboardRepairData){
                if(state.dashboardRepairData.openS && state.dashboardRepairData.openS.length > 0){
                    oldCommId = state.dashboardRepairData.openS[0].communityId
                } else if(state.dashboardRepairData.closeS && state.dashboardRepairData.closeS.length > 0){
                    oldCommId = state.dashboardRepairData.closeS[0].communityId
                }
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'dashboardRepairData': {
                    ...action.data,
                    openS: (commId === oldCommId)? state.dashboardRepairData.openS : [],
                    closeS: (commId === oldCommId)? state.dashboardRepairData.closeS : [],
                },
                'type': action.type
            });
        case REPAIR_OPEN_SUCCESS:
        case REPAIR_CLOSE_SUCCESS:
        case REPAIR_CLOSE_ERROR:
        case REPAIR_OPEN_ERROR:

            const initialData = action.data;
            const newCommunityId = (action && action.communityId)? action.communityId : undefined;
            let oldCommunityId =  undefined;

            
            if(state && state.dashboardRepairData){
                if(state.dashboardRepairData.openS && state.dashboardRepairData.openS.length > 0){
                    oldCommunityId = state.dashboardRepairData.openS[0].communityId
                } else if(state.dashboardRepairData.closeS && state.dashboardRepairData.closeS.length > 0){
                    oldCommunityId = state.dashboardRepairData.closeS[0].communityId
                }
            }
            
            if (state.dashboardRepairData && newCommunityId === oldCommunityId  ) {
                const repairData =  _.cloneDeep(state.dashboardRepairData) ;
                const actionData = action.data;
                if (action.type === REPAIR_OPEN_SUCCESS || action.type === REPAIR_OPEN_ERROR) {
                    const oldRepairs = repairData.openS.filter(repair => !actionData.some(open => open._id === repair._id));
                    

                    //const oldRepairs = repairData.openS;
                    repairData.openS = oldRepairs.concat(actionData);


                    repairData.openS.sort((a, b) => {

                        if (new Date(a.createdDate) > new Date(b.createdDate)) {
                            return -1;
                        } else {
                            return 1;
                        }
                    });
                }

                if (action.type === REPAIR_CLOSE_SUCCESS || action.type === REPAIR_CLOSE_ERROR) {
                    const oldRepairs = repairData.closeS.filter(repair => !actionData.some(close => close._id === repair._id));
                    repairData.closeS = oldRepairs.concat(actionData);

                    repairData.closeS.sort((a, b) => {

                        if (new Date(a.createdDate) > new Date(b.createdDate)) {
                            return -1;
                        } else {
                            return 1;
                        }
                    });
                }

                action.data = repairData;
            } else if(state.dashboardRepairData){
                const repairData =  _.cloneDeep(state.dashboardRepairData) ;
                const actionData = action.data;

                if (action.type === REPAIR_OPEN_SUCCESS || action.type === REPAIR_OPEN_ERROR) {                    
                    repairData.openS = actionData
                }

                if (action.type === REPAIR_CLOSE_SUCCESS || action.type === REPAIR_CLOSE_ERROR) {
                    repairData.closeS =actionData;
                }

                action.data = repairData;
            }
            
            if((newCommunityId !== oldCommunityId || !oldCommunityId ) && action.type === HISTORIC_DASHBOARD_REPAIR_SUCCESS){
                action.data = initialData;
            }
            
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'dashboardRepairData': action.data,
                'type': action.type
            });

        case CLOSE_REPAIR_SUCCESS:

            let arr = state.dashboardRepairData.openS;

            action.data.forEach(rep => {
                arr = arr.filter(x=>x._id!==rep._id);
            });

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'dashboardRepairData': {...state.dashboardRepairData, openS: arr},
                'type': action.type
            });

        case CANCEL_REPAIR_SUCCESS:
    
            let arrOpen = state.dashboardRepairData.openS;
    
            action.data.forEach(rep => {
                arrOpen = arrOpen.filter(x=>x._id!==rep._id);
            });
        
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'dashboardRepairData': {...state.dashboardRepairData, openS: arrOpen},
                'type': action.type
            });

        default:
            return state;
    }
}

export default repairReducer;

